/* eslint-disable */

export const protobufPackage = "od_protos.common";

export interface DateMessage {
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year: number;
  /** Month of year. Must be from 1 to 12. */
  month: number;
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year/month where the day is not significant.
   */
  day: number;
}

export interface Time {
  /** Hours of a time, where 0 is midnight, 12 is noon, and 13 is 1pm. */
  hours: number;
  /** Minutes of a time. */
  minutes: number;
}

export interface DateTime {
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year: number;
  /** Month of year. Must be from 1 to 12. */
  month: number;
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year/month where the day is not significant.
   */
  day: number;
  /** Hours of a time, where 0 is midnight, 12 is noon, and 13 is 1pm. */
  hours: number;
  /** Minutes of a time. */
  minutes: number;
}

function createBaseDateMessage(): DateMessage {
  return { year: 0, month: 0, day: 0 };
}

export const DateMessage = {
  fromJSON(object: any): DateMessage {
    return {
      year: isSet(object.year) ? Number(object.year) : 0,
      month: isSet(object.month) ? Number(object.month) : 0,
      day: isSet(object.day) ? Number(object.day) : 0,
    };
  },

  toJSON(message: DateMessage): unknown {
    const obj: any = {};
    if (message.year !== 0) {
      obj.year = Math.round(message.year);
    }
    if (message.month !== 0) {
      obj.month = Math.round(message.month);
    }
    if (message.day !== 0) {
      obj.day = Math.round(message.day);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateMessage>, I>>(base?: I): DateMessage {
    return DateMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateMessage>, I>>(object: I): DateMessage {
    const message = createBaseDateMessage();
    message.year = object.year ?? 0;
    message.month = object.month ?? 0;
    message.day = object.day ?? 0;
    return message;
  },
};

function createBaseTime(): Time {
  return { hours: 0, minutes: 0 };
}

export const Time = {
  fromJSON(object: any): Time {
    return {
      hours: isSet(object.hours) ? Number(object.hours) : 0,
      minutes: isSet(object.minutes) ? Number(object.minutes) : 0,
    };
  },

  toJSON(message: Time): unknown {
    const obj: any = {};
    if (message.hours !== 0) {
      obj.hours = Math.round(message.hours);
    }
    if (message.minutes !== 0) {
      obj.minutes = Math.round(message.minutes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Time>, I>>(base?: I): Time {
    return Time.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Time>, I>>(object: I): Time {
    const message = createBaseTime();
    message.hours = object.hours ?? 0;
    message.minutes = object.minutes ?? 0;
    return message;
  },
};

function createBaseDateTime(): DateTime {
  return { year: 0, month: 0, day: 0, hours: 0, minutes: 0 };
}

export const DateTime = {
  fromJSON(object: any): DateTime {
    return {
      year: isSet(object.year) ? Number(object.year) : 0,
      month: isSet(object.month) ? Number(object.month) : 0,
      day: isSet(object.day) ? Number(object.day) : 0,
      hours: isSet(object.hours) ? Number(object.hours) : 0,
      minutes: isSet(object.minutes) ? Number(object.minutes) : 0,
    };
  },

  toJSON(message: DateTime): unknown {
    const obj: any = {};
    if (message.year !== 0) {
      obj.year = Math.round(message.year);
    }
    if (message.month !== 0) {
      obj.month = Math.round(message.month);
    }
    if (message.day !== 0) {
      obj.day = Math.round(message.day);
    }
    if (message.hours !== 0) {
      obj.hours = Math.round(message.hours);
    }
    if (message.minutes !== 0) {
      obj.minutes = Math.round(message.minutes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DateTime>, I>>(base?: I): DateTime {
    return DateTime.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DateTime>, I>>(object: I): DateTime {
    const message = createBaseDateTime();
    message.year = object.year ?? 0;
    message.month = object.month ?? 0;
    message.day = object.day ?? 0;
    message.hours = object.hours ?? 0;
    message.minutes = object.minutes ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
